module.exports = vendor_874d99dc045348329ffe;